import "./ModalOverlay.scss";

function ModalOverlay() {
  return <div className="modalOverlay"></div>;
}

export default ModalOverlay;
